import React, { useState, useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { UserState } from '../../../../../utils/recoil/user';
import { NativeSelect } from '../NativeSelect/nativeSelect';

export const ProvinceSelect = (props) => {
  const { watch } = props;
  const user = useRecoilValue(UserState);
  const [provinces, setProvinces] = useState(null);

  const currentCountry = watch('country', false);

  useEffect(() => {
    if (user) {
      if (user.availableShoppingCountries) {
        user.availableShoppingCountries.forEach((country) => {
          if (country.name === currentCountry) {
            setProvinces(country.provinces);
          }
        });
      }
    }
  }, [currentCountry]);

  return (
    provinces &&
    provinces.length > 0 && (
      <NativeSelect
        required
        native
        {...props}
        values={provinces.map(({ name }) => ({
          label: { text: name },
          value: name,
        }))}
      />
    )
  );
};
